import {
    CacheablePayloadStore,
    ICacheablePayloadAction,
} from "../../../../../../../../react-core/Flux/CacheablePayloadStore";
import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { TrustDetail } from "../../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { ProductsValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";
import { SippIncome } from "../../../../../../../../Wrap/Models/Domains/Valuation/SippIncome";
import { PortfolioPerformanceSummaryModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSummaryModel";
import { PortfolioPerformanceSimpleReturnAndIRRModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSimpleReturnAndIRRModel";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";
import { SingleDataStore } from "../../../../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../../../../Shared/Stores/SingleDataStoreDispacher";

export const PortfolioDashboardSummaryDisaptcher: SingleDataStoreDispacher<string[]> = new SingleDataStoreDispacher<
    any
>();
export const PortfolioDashboardSummaryStore: SingleDataStore<string[]> = new SingleDataStore<any>(
    PortfolioDashboardSummaryDisaptcher
);

export interface ProductsValuationDetailSummaryQuery {
    headAccountHierarchyIds: Array<string>;
    subAccountHierarchyIds: Array<string>;
    assetClassType: AssetClassType;
    asAt: IJsonDate;
}

export interface PortfolioPerformanceSummaryQuery {
    hierarchyId: string;
    fromDateTime: IJsonDate;
    toDateTime: IJsonDate;
    fromInception: boolean;
    performanceMethod: PerformanceMethod;
}

export interface PortfolioPerformancesimplereturnAndIrrQuery {
    hierarchyId: string;
    fromDateTime: IJsonDate;
    toDateTime: IJsonDate;
    performanceMethod: PerformanceMethod;
}

export const SummaryTrustDetailsDisaptcher = new Dispatcher<ICacheablePayloadAction<TrustDetail[], string[]>>();
export const SummaryTrustDetailsStore = new CacheablePayloadStore(SummaryTrustDetailsDisaptcher);

export const ProductsValuationDetailSummaryDispatcher = new Dispatcher<
    ICacheablePayloadAction<ProductsValuationDetailSummary, ProductsValuationDetailSummaryQuery>
>();
export const ProductsValuationDetailSummaryStore = new CacheablePayloadStore(ProductsValuationDetailSummaryDispatcher);

export const PortfolioPerformanceSummaryDispatcher = new Dispatcher<
    ICacheablePayloadAction<PortfolioPerformanceSummaryModel, PortfolioPerformanceSummaryQuery>
>();
export const PortfolioPerformanceSummaryStore = new CacheablePayloadStore(PortfolioPerformanceSummaryDispatcher);

export const PortfolioPerformanceSimpleReturnAndIRRDispatcher = new Dispatcher<
    ICacheablePayloadAction<PortfolioPerformanceSimpleReturnAndIRRModel, PortfolioPerformancesimplereturnAndIrrQuery>
>();
export const PortfolioPerformanceSimpleReturnAndIRRStore = new CacheablePayloadStore(
    PortfolioPerformanceSimpleReturnAndIRRDispatcher
);

export const SippIncomeDispatcher = new Dispatcher<ICacheablePayloadAction<SippIncome, string>>();
export const SippIncomeStore = new CacheablePayloadStore(SippIncomeDispatcher);
